import React from 'react';
import { Microscope, Activity, ShieldCheck } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const DiagnosticServicesPage = () => {
  const config = {
    badge: "Diagnostic Excellence",
    headline: "Advanced",
    headlineItalic: "Diagnostics.",
    subtext: "Cutting-edge diagnostic technologies that deliver fast, accurate results — empowering better clinical decisions and faster treatment pathways.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Advanced Diagnostics at Dr. Suresh Pet Care — PCR and In-House Lab",
    stats: [
      { value: 20000, suffix: '+', label: 'Tests Performed' },
      { value: 99, suffix: '%', label: 'Lab Accuracy Rate' },
      { value: 30, suffix: ' Min', label: 'Most Results' },
      { value: 24, suffix: '/7', label: 'Emergency Lab' },
    ],
    services: [
      {
        title: "PCR & Molecular Testing",
        icon: <Microscope size={28} />,
        desc: "PCR-based molecular diagnostics for precise identification of viral, bacterial, and parasitic pathogens.",
        specs: ["Viral PCR", "Tick-borne Disease", "Fungal Identification", "Leishmaniasis"],
        color: "from-teal-500/10 to-primary/10"
      },
      {
        title: "V-Check Rapid",
        icon: <Activity size={28} />,
        desc: "In-clinic rapid diagnostic testing for critical biomarkers with near-instant results for urgent cases.",
        specs: ["CRP Detection", "Progesterone", "NT-proBNP Cardiac", "Feline Leukemia"],
        color: "from-primary/10 to-blue-500/10"
      },
      {
        title: "Electronic Medical Records",
        icon: <ShieldCheck size={28} />,
        desc: "Digital patient health records ensuring comprehensive care history, prescription tracking, and owner access.",
        specs: ["Digital Records", "Prescription History", "Lab Integration", "Owner Portal"],
        color: "from-green-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Diagnostic",
    sectionItalic: "Technologies.",
    warningTitle: "When Diagnostics",
    warningItalic: "Are Critical.",
    warningText: "Accurate diagnostics are the foundation of effective treatment. These signs indicate where rapid testing can be life-saving.",
    warnings: [
      { name: "Unknown Illness", desc: "Comprehensive bloodwork and PCR testing identifies cause of illness swiftly.", icon: "🔬" },
      { name: "Pre-Surgical Clearance", desc: "Lab tests confirm organ function and coagulation status before any procedure.", icon: "✅" },
      { name: "Monitoring Chronic Disease", desc: "Regular lab testing tracks disease progression and treatment efficacy.", icon: "📊" },
      { name: "Infectious Disease Exposure", desc: "PCR confirms or rules out contagious disease in multi-pet households.", icon: "⚠️" },
    ],
    ctaBadge: "Diagnostic Lab",
    ctaTitle: "The Diagnostic",
    ctaItalic: "Expertise.",
    ctaText: "Our fully-equipped in-house laboratory delivers rapid, NABL-standard results, enabling same-visit diagnosis and treatment decisions for your pet.",
    ctaBtn: "Book Diagnostic Tests",
    seoText: "Advanced veterinary diagnostics in Hyderabad. PCR testing, V-Check Rapid, and in-house lab at Dr. Suresh Pet Care. Precision diagnostic services for pets.",
    glowColor: "teal-500"
  };

  return (
    <>
      <SEO 
        title="Advanced Veterinary Diagnostics"
        description="Comprehensive diagnostic services including PCR testing, V-Check Rapid, and electronic medical records at Dr. Suresh Pet Care, Hyderabad."
        canonical="/diagnostic-services"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default DiagnosticServicesPage;
